export default __webpack_public_path__ + "img/triangle_pr.1553eb1.svg";